import React, { useContext } from 'react';

import styled from '@emotion/styled';

import useAcceptVerifyData from '../../../../hooks/dashboard/BaDriverVerification/useAcceptVerifyData';
import { verifyNINAction } from '../../../../redux/slices/verifyNINSlice';
import { useAppDisPatch, useAppSelector } from '../../../../redux/store';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import TriangleCautionIcon from '../../../Icons/TriangleCautionIcon';
import Table from '../../../Table/Table';
import { TableContext } from '../../../Table/TableContext';
import TableScroller from '../../../Table/TableScroller';
import { ModalContext } from '../../ModalContext';

interface ConfirmNINVerificationProps {
  data?: any;
}

const ConfirmNINVerification: React.FC<ConfirmNINVerificationProps> = ({
  data,
}) => {
  const modalContext = useContext(ModalContext);
  const { acceptVerifyData, loading } = useAcceptVerifyData();
  const verifyNINState = useAppSelector((state) => state.verifyNIN);
  const tableContext = useContext(TableContext);

  const dispatch = useAppDisPatch();

  const onSubmit = () => {
    acceptVerifyData(data?.id ?? '', () => {
      modalContext?.setShowModal(false);
      dispatch(verifyNINAction.resetSliderIndex());
      tableContext?.setRefreshTable(!tableContext?.refreshTable);
    });
  };

  const handleBackToPrevious = () => {
    dispatch(verifyNINAction.setSliderIndex(-1));
  };

  return (
    <Container className={verifyNINState.sliderIndex < 1 ? 'inactive' : ''}>
      <Flex>
        <Banner>
          <TriangleCautionIcon />
          100 naira has been incurred for NIN verification
        </Banner>

        <TableScroller>
          <Table
            className='scrollable-table'
            tableHeader={{
              'Field Verifiable': 'fieldVerifiable',
              'Driver Information': 'driverInformation',
              'Verified Data': 'verifiedData',
            }}
            tableDataSourceUrl={`ba/v1/drivers/onboarding/verification-data/${data?.nin ?? ''}`}
            continuousView
            key={verifyNINState.sliderIndex}
          />
        </TableScroller>

        <ButtonArea>
          <FormSubmitButton
            className='clear fill red text-white'
            onClick={handleBackToPrevious}
            btnType='button'
          >
            Reject
          </FormSubmitButton>
          <FormSubmitButton
            loading={loading}
            btnType='button'
            onClick={onSubmit}
            className='fill'
          >
            Approve
          </FormSubmitButton>
        </ButtonArea>
      </Flex>
    </Container>
  );
};

export default ConfirmNINVerification;

const ButtonArea = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
`;

const Container = styled.div`
  display: flex;

  &.inactive > * {
    display: none;
  }
`;

const Flex = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const Banner = styled.div`
  font-weight: 600;
  font-size: 16px;
  width: 100%;
  border-radius: 6px;
  padding: 16px;
  background-color: rgba(255, 5, 0, 0.05);
  border-radius: 8px;
  color: #41415a;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;

  & > svg {
    color: #5b91f5;
  }
`;
